










































































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import ModalRegraDeCalculoIncluirContrato from './ModalRegraDeCalculoIncluirContrato.vue'

@Component({
  components: {
    ModalRegraDeCalculoIncluirContrato,
  },
})
export default class ContratosDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get selected() { return this.getRegrasDeCalculoStore.contratosId }
  set selected(value: any) { this.getRegrasDeCalculoStore.setContratosId(value) }

  loadContratos: boolean = false
  get loadingContratos() { return this.loadContratos }
  set loadingContratos(value: boolean) { this.loadContratos = value }

  get regraDeCalculoContratosHeaders() {
    return [
      { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false },
      { text: 'Prestador', value: 'prestadorNome', sortable: false },
      { text: 'Incluído por', value: 'createdByNome', sortable: false },
      { text: 'Incluído em', value: 'createdOn', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get regraDeCalculoContratos() { return this.getRegrasDeCalculoStore.regraDeCalculoContratos }
  get paginacaoContratos() { return this.getRegrasDeCalculoStore.paginacaoContratos }
  contratosDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegraCalculoContratoAll(param), 700)

  async updatePaginationContratos(pagination: DataTablePagination) {
    if (!this.getRegrasDeCalculoStore.modal.regraDeCalculo) return
    this.loadingContratos = true
    this.contratosDebounced(pagination)
    this.loadingContratos = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeletarRegraDeCalculoContrato: string = ''
  get loadingDeletarRegraDeCalculoContrato() { return this.loadDeletarRegraDeCalculoContrato }
  set loadingDeletarRegraDeCalculoContrato(value: string) { this.loadDeletarRegraDeCalculoContrato = value }

  async deletarRegraDeCalculoContrato(contratoId: string) {
    this.loadingDeletarRegraDeCalculoContrato = contratoId
    const request = await this.getRegrasDeCalculoStore.deleteRegraCalculoContrato(contratoId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarRegraDeCalculoContrato = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Contrato excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarRegraDeCalculoContrato = ''
  }

  loadPrestadorIdSearch: boolean = false
  get loadingPrestadorIdSearch() { return this.loadPrestadorIdSearch }
  set loadingPrestadorIdSearch(value: boolean) { this.loadPrestadorIdSearch = value }

  async getPrestadoresContratoByRegraCalculoId() {
    this.loadingPrestadorIdSearch = true
    await this.getRegrasDeCalculoStore.getPrestadoresContratoByRegraCalculoId()
    this.loadingPrestadorIdSearch = false
  }

  get prestadoresSearchList() { return this.getRegrasDeCalculoStore.prestadoresSearchList }
  get prestadorIdSearch() { return this.getRegrasDeCalculoStore.prestadorIdSearch }
  set prestadorIdSearch(value: string) { this.getRegrasDeCalculoStore.setPrestadorIdSearch(value) }

  async search() {
    await this.updatePaginationContratos(this.paginacaoContratos)
  }

  get showModalPostRegraCalculoContrato() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoContrato }
  set showModalPostRegraCalculoContrato(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoContrato', value }) }
}
